/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportPackageDTO } from './etransport-package-dto.model';
import { ETransportCommercialPartnerDTO } from './etransport-commercial-partner-dto.model';
import { ETransportShipmentDataDTO } from './etransport-shipment-data-dto.model';
import { ETransportLocationDTO } from './etransport-location-dto.model';
import { ETransportShipmentDocumentDTO } from './etransport-shipment-document-dto.model';

export class ETransportShipmentBaseDTO extends JSONable {
  packageDTOs: ETransportPackageDTO[] = [new ETransportPackageDTO()];
  commercialPartnerDTO: ETransportCommercialPartnerDTO | null = new ETransportCommercialPartnerDTO();
  shipmentDataDTO: ETransportShipmentDataDTO | null = new ETransportShipmentDataDTO();
  startLocationDTO: ETransportLocationDTO | null = new ETransportLocationDTO();
  endLocationDTO: ETransportLocationDTO | null = new ETransportLocationDTO();
  shipmentDocumentDTOs: ETransportShipmentDocumentDTO[] | null = [new ETransportShipmentDocumentDTO()];
  fromCurrencyCode: string | null = null;
  fromExchangeRate: number | null = null;
}
